<template>
    <div>
        <rkm-area
            title="Paciente"
            type="fieldset"
            no-margin-top
            v-if="paciente.nome"
        >

            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}
                                <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                    ({{ paciente.nomeSocial }})
                                </strong>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">

                            <p>
                                <strong>Prontuário:</strong>
                                {{ paciente.prontuario }}
                            </p>

                            <p>
                                <strong>Telefone: </strong>
                                <template v-if="paciente.telefone">
                                    {{ paciente.telefone | formatPhoneOrCellPhone }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Sexo: </strong>
                                <template v-if="paciente.sexoId">
                                    {{ paciente.sexoDescricao }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Unidade de referência: </strong>
                                <template v-if="paciente.unidadeReferencia">
                                    {{ paciente.unidadeReferencia }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="4">
                            <p>
                                <strong>CPF: </strong>
                                <template v-if="paciente.cpf">
                                    {{ paciente.cpf | formatCpf }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Data de nascimento: </strong>
                                <template v-if="paciente.dataNascimento">
                                    {{ paciente.dataNascimento }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>
                                    Raça/cor:
                                </strong>
                                <template>
                                    {{ paciente.racaCor }}
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="4">
                            <p>
                                <strong>CNS: </strong>
                                <template v-if="paciente.cns">
                                    {{ paciente.cns | formatCns }}
                                </template>

                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Idade: </strong>
                                <template v-if="paciente.idade">
                                    {{ paciente.anos }} anos,
                                    {{ paciente.meses }} meses e
                                    {{ paciente.dias }} dias
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>
                                    Nome da mãe:
                                </strong>
                                <template v-if="paciente.nomeMae">
                                    {{ paciente.nomeMae }}
                                </template>
                                <template v-else>
                                    <i>Desconhecido</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>

// Filters.
import format from '@/filters/formats'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    data: () => ({
        enums: {
            preferenciaNome
        },
    }),
    filters: {
        ...format,
    },
    props: {
        paciente: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>